// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3SgGS","spin":"Loading_spin__2KgBV"};